import {IntermediatePart} from "../../intermediatePart";

export default class TallCabinet extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'tall_cabinet';
    this.partName = 'Tall Cabinet';
    this.translateId = "visualizer.kitchen.cabinet.tall_cabinet";
    this.hasAdditionalParts = true;
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    const partNumber = (dbFeature.metaData["Part"] && +dbFeature.metaData["Part"][0]) === 1 ? 1 : 2;
    return super.load_(dbFeature, new TallCabinet(false, partNumber), true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  handleClick(ignoreLocked, clickFrom = "") {
    const parent = this.getParent();
    if (parent.getParent && parent.getParent()) {
      super.handleClick(ignoreLocked, clickFrom);
      parent.activeFeatureParts = parent.setActiveFeatureParts();
    } else {
      parent.bottomCabinet.activeFeature = this;
    }
    this.featureClicked();
  }

  disabledClick() {
    const cabinetParent = this.getParent();
    if (cabinetParent.tallCabinetLeg) {
      cabinetParent.tallCabinetLeg.disabled = this.disabled;
    }
    if (cabinetParent.tallHandle) {
      cabinetParent.tallHandle.disabled = this.disabled;
    }
    this.activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
  }

}
